// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__o6fLg","empty":"style_empty__u5yKs"};